export const toPhoneFieldValue = (value: unknown): string => {
	if (typeof value !== 'string') {
		return '';
	}

	return value;
};
